// import i18n from '../.././i18n/i18n';

export default [
  {
    sutraId: 1,
    name: '淨行品2',
    sutraImg: '/static/image/content/purifying-s01.png',
    sutraDes: 'sutraDescribe',
  },
  {
    sutraId: 2,
    name: '十地品',
    sutraImg: '/static/image/noimage.jpg',
    sutraDes: 'sutraDescribe',
  },
  {
    sutraId: 3,
    name: '普賢品',
    sutraImg: '/static/image/noimage.jpg',
    sutraDes: 'sutraDescribe',
  },
  {
    sutraId: 4,
    name: '如來品',
    sutraImg: '/static/image/noimage.jpg',
    sutraDes: 'sutraDescribe',
  },
];



// WEBPACK FOOTER //
// ./src/components/data/sutraData.js